export default __webpack_public_path__ + "static/media/eth-icon.df265e36.svg";